/**
 *
 * HeadlinePanel
 *
 */
import React from "react";
import { Container, Row } from "react-bootstrap";
import {
  PendingTestsData,
  PendingInvitationsData,
  DirectReport
} from "../types";
import { UserWelcome } from "./UserWelcome";
import { PendingActions } from "./PendingActions";

export interface Props {
  user: User | null;
  pendingTests: PendingTestsData[] | null;
  pendingActions: Array<PendingInvitationsData | DirectReport> | null;
  isLoading: boolean;
  acceptInvitation: (
    teamMemberId: number,
    teamId: number,
    teamName: string
  ) => void;
  setShowInviteLinkModal: any;
  hasSSOHardEnabled: boolean;
  allowUsersShareInviteLink: number | undefined;
}

export function HeadlinePanel({
  user,
  pendingTests,
  isLoading,
  acceptInvitation,
  setShowInviteLinkModal,
  hasSSOHardEnabled,
  allowUsersShareInviteLink,
  pendingActions
}: Props) {
  return (
    <div className="headline-panel">
      <Container>
        <Row>
          <UserWelcome
            user={user}
            numberOfActions={
              pendingTests && pendingActions
                ? pendingTests.length + pendingActions.length
                : 0
            }
            isLoading={isLoading}
            setShowInviteLinkModal={setShowInviteLinkModal}
            hasSSOHardEnabled={hasSSOHardEnabled}
            allowUsersShareInviteLink={allowUsersShareInviteLink}
          />
          <PendingActions
            pendingActions={pendingActions} // pending Invitations + un-viewed Manager Guide
            isLoading={isLoading}
            acceptInvitation={acceptInvitation}
          />
        </Row>
      </Container>
    </div>
  );
}
